import { render, staticRenderFns } from "./EsgReport.vue?vue&type=template&id=7b206873&scoped=true"
import script from "./EsgReport.vue?vue&type=script&setup=true&lang=js"
export * from "./EsgReport.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EsgReport.vue?vue&type=style&index=0&id=7b206873&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b206873",
  null
  
)

export default component.exports